import React from 'react';
import PropTypes from 'prop-types';
import { RenderModule } from 'holocron';
import { useIsCenturionContext } from '../../context/isCenturionContext';
import { TERMS_MODULE_NAME } from '../../constants/modules';

const Terms = ({ showVacationRentals }) => {
  const isCenturion = useIsCenturionContext();
  const termsAndConditionsToShow = [
    ...isCenturion ? ['centurion'] : ['homepage'],
    ...showVacationRentals ? ['star'] : [],
  ];

  return (
    <RenderModule
      moduleName={TERMS_MODULE_NAME}
      props={{ programs: termsAndConditionsToShow }}
    />
  );
};

Terms.propTypes = {
  showVacationRentals: PropTypes.bool.isRequired,
};

export default Terms;
